import React from 'react';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import {JsonAdSummary} from '../../ext/lib/types';
import {displayJsonDate} from '../../ext/lib/temporal';
import {displayAdCost, invoiceNumber} from '../../ext/billing';
import * as R from 'ramda';

type MaybeAds = JsonAdSummary[] | null;

type Props = {
  ads: MaybeAds,
  emptyMessage: string
};

// TypeScript is not co-operating when React.FC<T> is used.
export default function adSummaryList<T extends { ad: JsonAdSummary }>(AdActions?: any): React.FC<Props & T> {
  return (props: Props): React.ReactElement => {
    const adRow: (_: JsonAdSummary) => React.ReactNode =
      (ad: JsonAdSummary) =>
        <TableRow key={ad.adKey}>
          <TableCell style={{textAlign: 'center'}}>
            {displayJsonDate(ad.firstDate)}<br />to<br />{displayJsonDate(ad.lastDate)}
          </TableCell>
          <TableCell>{ad.organization}</TableCell>
          <TableCell>{ad.adName}</TableCell>
          <TableCell>
            <div>{ad.userFirstName} {ad.userLastName}</div>
            <div>{ad.contactPhoneNum}</div>
            <div>{ad.userEmailAddress}</div>
          </TableCell>
          <TableCell>{invoiceNumber(ad)}</TableCell>
          <TableCell>{ad.rechargeNumber}</TableCell>
          <TableCell>{ad.slideCount}</TableCell>
          <TableCell>{displayAdCost(ad)}</TableCell>
          <TableCell style={{overflowWrap: 'anywhere'}}>{ad.comments}</TableCell>
          {AdActions ? <TableCell><AdActions ad={ad} {...props} /></TableCell> : null}
        </TableRow>;

    const renderTable =
      R.cond([
        [R.isNil, R.always(<div className="loading-spinner"></div>)],
        [R.isEmpty, (): React.ReactElement =>
          <Typography variant="h1">{props.emptyMessage}</Typography>],
        [R.T, (ads: JsonAdSummary[]): React.ReactElement =>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Broadcast</TableCell>
                  <TableCell>Dept</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Contact</TableCell>{/* Name, Phone, Email */}
                  <TableCell>Invoice&nbsp;#</TableCell>
                  <TableCell>Recharge&nbsp;#</TableCell>
                  <TableCell>Slides</TableCell>
                  <TableCell>Fee</TableCell>{ /* With optional paid indicator */ }
                  <TableCell>Comments</TableCell>
                  {AdActions ? <TableCell>{/*Actions*/}</TableCell> : null}
                </TableRow>
              </TableHead>

              <TableBody>
                {R.map(adRow, ads)}
              </TableBody>
            </Table>
          </TableContainer>
        ]
      ]) as (_: MaybeAds) => JSX.Element;

    return renderTable(props.ads);
  };
}
